import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ManagerEmployeeModel } from "src/app/pos-panel/models/employees/manager-employee.model";

@Injectable({
  providedIn: 'root'
})
export class CurrentEmployeeHelperService {

  private updateSubject = new BehaviorSubject<any>(null);

  public onUpdate(): Observable<any> {
    return this.updateSubject.asObservable();
  }

  public updateCurrentEmployee(employee: ManagerEmployeeModel): void {
    if (this.updateSubject.getValue() !== employee) {
      this.updateSubject.next(employee);
    }
  }

  public resetCurrentEmployee(): void {
    this.updateSubject.next(null);
  }
}